export const GRID_VISIBILITY_OPTIONS = [
  { value: "owner_only", label: "Owner Only" },
  { value: "all_admins", label: "All Admins" },
  { value: "all_users", label: "All Users" },
];

export const normalizeGridsVisibility = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === "owner_only" || normalized === "owneronly") return "owner_only";
  if (normalized === "all_users" || normalized === "allusers") return "all_users";
  if (normalized === "all_admins" || normalized === "alladmins") return "all_admins";
  return "all_admins";
};

export const canViewGrids = ({ role, featureFlags = {} }) => {
  const normalizedRole = String(role || "").trim().toLowerCase();
  const visibility = normalizeGridsVisibility(featureFlags?.gridsVisibility);

  if (normalizedRole === "owner") return true;
  if (normalizedRole === "admin" || normalizedRole === "super_admin") {
    return visibility !== "owner_only";
  }

  if (normalizedRole === "enduser" || normalizedRole === "end_user") {
    return visibility === "all_users";
  }

  return false;
};

export const getGridsVisibilityLabel = (value) =>
  GRID_VISIBILITY_OPTIONS.find((option) => option.value === normalizeGridsVisibility(value))?.label || "All Admins";
